var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-crear",attrs:{"data-testid":"AgregarButton"},on:{"click":function($event){return _vm.handleClick()}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("add_circle_outline")]),_c('span',[_vm._v("Agregar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }